import React, { useRef } from 'react';

export const SelectableTag = ({
	name: tagName,
	selectedTag,
	setSelectedTag
}: {
	name: string;
	selectedTag: string;
	setSelectedTag: (tag: string) => void;
}) => {
	const refName = useRef<null>(null);

	const selectTag = () => {
		setSelectedTag(tagName);
	};

	return (
		<div
			onClick={selectTag}
			className={`flex relative justify-center items-center py-1.5 px-1 rounded-full w-fit transition-all duration-500 max-h-7 cursor-pointer group 
			${
				selectedTag === tagName
					? 'bg-purple-600 border-purple-400 dark:bg-purple-600 dark:border-purple-400 text-gray-200'
					: 'hover:bg-purple-600 dark:hover:bg-purple-500 bg-gray-400 dark:bg-gray-600 border-green-200 dark:text-gray-300 text-gray-600 hover:text-gray-200'
			}`}
		>
			<span ref={refName} className="text-xs font-bold mx-1">
				{tagName.toUpperCase()}
			</span>
		</div>
	);
};
